import { useState } from "react";
// import Modal from "../../components/modals/Modal";
import { Modal } from "../../components/widgets/Popup";

// import noNotes from "./../../assets/images/notes.png";

//button for creating notes
import {
  Confirm,
  Crear,
  Note,
} from "../../components/RequestPage/TabNotes/Notes";
// import { NotasDescription } from "../../components/RequestPage/TabNotes/NotesElements";
import Scrollbar from "../../components/widgets/Scrollbar";
import { useTranslation } from "react-i18next";

const TabNotes = ({
  noteType,
  requestState,
  handleUser,
  description,
  setDescription,
  handleCreateNote,
  noteUser,
  handleNoteType,
}: any) => {
  const [modal, setModal] = useState(false);

  const { t } = useTranslation()

  return (
    <div className="px-0 lg:px-8 text-sm sm:text-md">
      {modal ? (
        <Modal
          setModalActive={setModal}
          active={modal}
          height="60%"
          width="45%"
        >
          <Confirm
            noteUser={noteUser}
            setModalActive={setModal}
            noteType={noteType}
            handleUser={handleUser}
            requestState={requestState}
            description={description}
            setDescription={setDescription}
            handleCreateNote={handleCreateNote}
            handleNoteType={handleNoteType}
          />
        </Modal>
      ) : (
        <></>
      )}
      {requestState.notes.length > 0 ? (
        <div className="flex justify-between items-center w-full h-16">
          <p>{t("requestDetail.tabWorkOrder.associatedNotes")}</p>
          {requestState.active.StatusName !== "Cerrada" && (
            <div className="flex items-center justify-center">
              <Crear setModal={setModal} modal={modal} />
            </div>
          )}
        </div>
      ) : (
        <div className="flex flex-row-reverse w-full h-16">
          {requestState.active.StatusName !== "Cerrada" && (
            <div className="flex items-center justify-center">
              <Crear setModal={setModal} modal={modal} />
            </div>
          )}
        </div>
      )}
      <div></div>
      <Scrollbar>
        {requestState.notes.length > 0 ? (
          requestState.notes.map((note: any, index: any) => {
            if (note.isVisible === true) {
              return <Note key={index} note={note} />;
            }

            return <></>;
          })
        ) : (
          <div className="flex flex-col items-center justify-center h-96">
            <p className="text-sm sm:text-md md:text-large">
              {t("requestDetail.tabNotes.empty")}
            </p>
          </div>
        )}
      </Scrollbar>
    </div>
  );
};

export default TabNotes;
